/*eslint-disable */

let $ = window.jQuery;

$(window).on('load', function () {
    let container = $('#filter-posts');
    if (container.length > 0) {
        container.isotope({ //Isotope options, 'item' matches the class in the PHP
            itemSelector : '.post--js-filter-item',
            hiddenStyle: {
                opacity: 0
            },
            visibleStyle: {
                opacity: 1
            }
        });
        //Add the class selected to the item that is clicked, and remove from the others
        let optionSets = $('.js-filter'),
        optionLinks = optionSets.find('a');

        optionLinks.click(function(){
            let $this = $(this);
            // don't proceed if already selected
            if ( $this.hasClass('selected') ) {
                return false;
            }
         
            let optionSet = $this.parents('.js-filter');
            optionSets.find('.selected').removeClass('selected');
            $this.addClass('selected');

            //When an item is clicked, sort the items.
            let selector = $(this).attr('data-filter');
            container.isotope({ filter: selector });

            return false;
        });

        //Filter complete
        container.on( 'arrangeComplete', function( event, filteredItems ) {
            //matchheight on the visible items 
            $('[data-mh]').matchHeight({ remove: true });
            $.fn.matchHeight._maintainScroll = true;
            $.fn.matchHeight._applyDataApi();
            //And re-layout the grid  
            container.isotope('layout'); 
        });
    }
});

/*eslint-ensable */